export default {
	terms: "Villkor och Integritetspolicy",
	and: "Och",
	actions: {
		Submit: "Skicka in",
		BackToLogin: "Tillbaka till inloggning",
		Register: "Registrera dig",
		Logout: "Logga ut",
		Update: "Uppdatera",
		Verify: "Overiť",
		connect: "Anslut",
		Taptochange: "Tryck för att ändra"
	},
	rules: {
		isRequired: "Obligatoriskt",
		require: "{0} är obligatoriskt",
		valid: "{0} är inte ett giltigt {0}",
		cannotContainBlankStrings: "{0} kan inte innehålla tomma strängar"
	},
	options: {
		gender: ["Man", "Kvinna"]
	}
};
